import { getQaSelector } from '../../../../../utils/common'
import { Skeleton } from '../../../../Skeleton'
import {
  QA_NAME_REQUEST_BOARD_SKELETON_CARD,
  REQUEST_BOARD_SKELETON_CARDS,
} from '../../RequestBoard.constants'

import * as styles from './RequestBoardColumnSkeleton.module.css'

function RequestBoardColumnSkeleton({ cards = REQUEST_BOARD_SKELETON_CARDS }) {
  return cards.map(card => (
    <div
      {...getQaSelector({ value: QA_NAME_REQUEST_BOARD_SKELETON_CARD })}
      className={styles.RequestBoardColumnSkeleton}
      key={card}
    >
      <Skeleton className={styles.title} />
      <Skeleton className={styles.meta} />
    </div>
  ))
}

export default RequestBoardColumnSkeleton
